import React, { useState } from 'react';
import { useModal } from '../../../context/ModalContext';
import { ModalBase } from './ModalBase';

interface LoginForm {
  email: string;
  password: string;
}

export function LoginModal() {
  const { openModal } = useModal();
  const [form, setForm] = useState<LoginForm>({ email: '', password: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (field: keyof LoginForm) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <ModalBase>
      <h3 className="modal-box__title">Entrar</h3>
      <p className="modal-box__subtitle">Acesse sua conta WashPass</p>

      <label className="modal-form__label">
        E-mail <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="email"
        placeholder="seu@email.com"
        value={form.email}
        onChange={handleChange('email')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Senha <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="password"
        placeholder="••••••••"
        value={form.password}
        onChange={handleChange('password')}
        className="modal-form__input"
      />

      <button className="modal-form__submit" onClick={handleSubmit}>
        Entrar
      </button>

      {submitted && (
        <div className="modal-form__success">Login realizado com sucesso!</div>
      )}

      <p className="modal-form__footer-link">
        Não tem conta?{' '}
        <span onClick={() => openModal('cadastroCliente')}>Cadastre-se</span>
      </p>
    </ModalBase>
  );
}
